export enum EStatus {
  INFORMATIONAL = 'INFORMATIONAL',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export enum ENotificationType {
  PRODUCTS_LIST = 'PRODUCTS_LIST',
  SIMPLE_WITH_RELOAD = 'SIMPLE_WITH_RELOAD',
  WITH_HTML = 'WITH_HTML',
}

export const INIT_NOTIFICATION = 'initNotification';

export enum ENotificationPageType {
  COMPARATOR = 'COMPARATOR',
  PRODUCT_CART = 'CART',
}

export enum ENotificationEvent {
  ACTION_DID_CLICK_EVENT = 'actionDidClick',
}
